<template>
  <div>
  <user-menu />
  <div class="wrapper">
  <div class="content-wrapper tasklist-preview">
  <div class="container-wrapper center">
  <div><h3 class="d-inline heading">{{ tasklist_title }}</h3></div>
  <div class="heading-seperator"></div>
  <div class="margin-bottom-10"></div>
    <div class="col-md-12 counter_subtask-list" id="tasks">
      <div v-for = "(subtask, stindex) in subtasks">
        <div class="subtask-wrapper">
          <h4 class="panel-title">
            <b-link v-b-toggle="'collapse-' + subtask.id">
              <span class="counter_subtask-list__counter"></span>
              {{subtask.name}}
            </b-link>
          </h4>
          <b-collapse v-bind:id="'collapse-' + subtask.id" class="mt-2 subtask-wrapper">
            <b-card>
              <div class="col-md-12 override-padding counter_heading-list">
                <div v-for = "(heading, index) in subtask.headings">
                  <b-link v-b-toggle="'collapse-' + subtask.id + '-' + heading.id" size="sm" class="sub-heading">
                    <span class="counter_heading-list__counter"></span>
                    {{ heading.name }}
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                  </b-link>
                  <b-collapse v-bind:id="'collapse-' + subtask.id + '-' + heading.id" class="mt-2 task-wrapper">
                    <div class="col-md-12 override-padding counter_task-list">
                      <div v-for = "task in heading.tasks">
                        <b-card class="hidden-xs hidden-sm">
                          <div class="task-title">
                            <span class="counter_task-list__counter"></span>
                            {{ task.description }}
                          </div>
                        </b-card>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
              <div class="col-md-12 override-padding counter_task-list">
                <div v-for = "substasklisttask in subtask.tasks" class="task-wrapper">
                  <b-card class="hidden-xs hidden-sm">
                    <div class="task-title">
                      <span class="counter_task-list__counter"></span>
                      {{ substasklisttask.description }}
                    </div>
                  </b-card>
                </div>
              </div>
            </b-card>
          </b-collapse>
        </div>
      </div>

    </div>
    </div>
  </div>
</div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import router from '../../router/index.js';
import store from '../../store/store.js';

export default {
  data: function () {
    return {
      'subtasks': [],
       loading: false,
       id: '',
       tasklist_title: '',
       masterAdmin: false,
    }
  },
  methods: {

  },
  components: {
    UserMenu,
    GoBack,
  },
  created: function () {
    var roles = this.$store.state.roles;
    if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
      this.masterAdmin = true;
    }

    this.id = this.$route.params.task_list_id;
    axios.get('/tasklist-preview/' + this.id)
    .then(response =>  {
      this.tasklist_title = response.data.title;
      this.subtasks = response.data.subtasks;
    })
    .catch(function(error) {
      console.log(error);
    });
  },
  updated() {
    var e1_val = this.$route.query.e1;
    var e2_val = this.$route.query.e2;
    var e3_val = this.$route.query.e3;
    if(e1_val) {
      var ele = document.getElementById("collapse-" + e1_val);
      ele.style.display = 'block';
      var ele2 = ele.parentElement.getElementsByClassName("panel-title")[0].getElementsByTagName("a")[0];
      ele2.className = '';
      var ele1 = document.getElementById("collapse-" + e1_val + "-" + e2_val);
      ele1.style.display = 'block';
      document.getElementById(e3_val).scrollIntoView(false);
    }
  },

}
</script>

<style scoped>
.back-btn-wrapper {
  width:100%;
  margin-left: 10px;
  margin-right: 0px;
}
.card-body a:hover{
  color: #FFF;
  text-decoration: none;
}
.task-wrapper .card {
  width: 99%;
  margin-left: auto;
  margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/manager/my_tasklists_details.vue